module.exports = __webpack_public_path__ + "static/img/success.bef457e4.png";